<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="900"
    scrollable
  >
    <v-card
      tile
      min-height="310"
      :loading="!userId"
    >
      <v-card-title
        class="primary font-weight-medium grey--text pt-1 pb-2 px-3"
      >
        Cambio de mi contraseña | Gestor
      </v-card-title>
      <v-card-subtitle class="primary pb-2 px-3">
        Complete los siguientes datos
      </v-card-subtitle>
      <v-card-text class="px-0">
        <pre></pre>
        <v-container fluid>
          <!-- <v-row no-gutters> -->
            <!-- <v-col cols="12"> -->
              <v-row>
                <v-col cols="11">
                <v-text-field
                  v-model="form.old_password"
                  label="Contraseña actual"
                  name="old_password"
                  append-icon="mdi-at"
                  type="password"
                  :error-messages="errorsOldPassword"
                  @blur="$v.form.old_password.$touch()"
                  :hide-details="!$v.form.password.$error"
                />
                </v-col>

                <v-col cols="11">
                <v-text-field
                  v-model="form.password"
                  label="Nueva contraseña"
                  name="password"
                  append-icon="mdi-at"
                  type="password"
                  :error-messages="errorsPassword"
                  @blur="$v.form.password.$touch()"
                  :hide-details="!$v.form.password.$error"
                />
                </v-col>
                <v-col cols="11">
                <v-text-field
                  v-model="form.repeat_password"
                  label="Confirmar contraseña"
                  name="password"
                  append-icon="mdi-lock"
                  type="password"
                  :error-messages="errorsRepeatPassword"
                  @blur="$v.form.repeat_password.$touch()"
                  @focus="removeServerError('new_password2')"
                  :hide-details="!$v.form.repeat_password.$error &&
                    !this.serverErrors.new_password2"
                />
                </v-col>

              </v-row>
            <!-- </v-col> -->
          <!-- </v-row> -->
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="grey"
          @click="closeDialog"
        >
          Cancelar
        </v-btn>
        <v-btn
          depressed
          color="success"
          @click="resetPassword"
          :loading="sending"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import types from '@/types';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';

export default {
  props: [
    'value',
    'userId',
  ],

  data() {
    return {
      sending: false,
      form: {
        user_id: '',
        old_password: '',
        password: '',
        repeat_password: '',
      },
      serverErrors: {},
    };
  },

  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8),
      },
      repeat_password: {
        required,
        sameAs: sameAs('password'),
      },
      old_password: {
        required,
        minLength: minLength(8),
      },
    },
  },

  watch: {
    dialog(value) {
      if (value) {
        this.form.user_id = this.userId;
        this.form.old_password = '';
        this.form.password = '';
        this.form.repeat_password = '';
      }
    },
    deep: true,
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    errorsOldPassword() {
      const errors = [];
      if (!this.$v.form.old_password.$dirty) { return errors; }
      if (!this.$v.form.old_password.required) {
        errors.push('Introduzca la contraseña.');
      }
      if (!this.$v.form.old_password.minLength) {
        errors.push('La contraseña debe contener minimo 8 caracteres');
      }
      return errors;
    },
    errorsPassword() {
      const errors = [];
      if (!this.$v.form.password.$dirty) { return errors; }
      if (!this.$v.form.password.required) {
        errors.push('Introduzca la contraseña.');
      }
      if (!this.$v.form.password.minLength) {
        errors.push('La contraseña debe contener minimo 8 caracteres');
      }
      return errors;
    },
    errorsRepeatPassword() {
      const errors = [];
      if (!this.$v.form.repeat_password.$dirty) { return errors; }
      if (!this.$v.form.repeat_password.required) {
        errors.push('Confirm your password.');
      }
      if (!this.$v.form.repeat_password.sameAs) {
        errors.push('Password must match.');
      }
      if (this.serverErrors.new_password2) {
        errors.push(this.serverErrors.new_password2.toString());
      }
      return errors;
    },
  },

  methods: {
    ...mapMutations(
      `${types.APP}`, [
        types.SHOW_BUSY,
        types.HIDE_BUSY,
        types.SHOW_SUCCESS,
        types.SHOW_ERROR,
      ],
    ),
    ...mapActions({
      [types.RESET_MY_PASSWORD]: `${types.USER}/${types.RESET_MY_PASSWORD}`,
    }),
    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.$v.$reset();
      }, 500);
    },
    resetPassword() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this.sending = true;
      this[types.RESET_MY_PASSWORD](this.form)
        .then(() => {
          this[types.SHOW_SUCCESS]('Contraseña modificada.');
          this.closeDialog();
        })
        .catch(() => {
          this[types.SHOW_ERROR]('Valide que la contraseña actual es correcta');
        })
        .finally(() => {
          this.sending = false;
        });
    },
    removeServerError(field) {
      delete this.serverErrors[field];
    },

  },

};
</script>



// WEBPACK FOOTER //
// src/components/UserResetMyPassword.vue